import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getDraftOrPublishedSchedule = api(async function getDraftOrPublishedSchedule(
    { projectId, scheduleId },
    { fetchPolicy } = {}
) {
    if (!projectId || !scheduleId) return null
    return query(
        gql`
            query GetDraftOrPublishedSchedule($projectId: String!, $scheduleId: String!) {
                getDraftOrPublishedSchedule(projectId: $projectId, scheduleId: $scheduleId) {
                    id
                    _id
                    isDraft
                    status
                    reviewCycle
                    seedSource
                    title
                    code
                    unitOfMeasure
                    version
                    metadata {
                        published
                    }
                    intro {
                        content
                        note
                    }
                    tasks {
                        id
                        content
                        title
                        note
                        isHeader
                        minutes
                        taskId
                        headerTaskId
                        classification
                        componentRef
                        linkedFields
                        frequency {
                            period
                            interval
                        }
                        skillSet
                        unitOfMeasure
                    }
                    currentlyDeletedTasks {
                        id
                        content
                        title
                        note
                        isHeader
                        minutes
                        taskId
                        headerTaskId
                        classification
                        componentRef
                        linkedFields
                        frequency {
                            period
                            interval
                        }
                        skillSet
                        unitOfMeasure
                    }
                    legislation
                }
            }
        `,
        { projectId, scheduleId },
        {
            returns: "getDraftOrPublishedSchedule",
            fetchPolicy,
        }
    )
})
